import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import routesSlice from './slices/routesSlice';
import adminAuthSlice from './slices/adminAuthSlice';
import adminRouteSlice from './slices/adminRouteSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    routes: routesSlice,
    adminAuth: adminAuthSlice,
    adminRoutes: adminRouteSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 